// extracted by mini-css-extract-plugin
export default {"options":"FormItems_options__3n0fa","entityIcon":"FormItems_entityIcon__9UCe0","collapse":"FormItems_collapse__Lzrbv","paneWrapper":"FormItems_paneWrapper__Z0v6s"};